import { axios } from '@/utils/request'

const api = {
  configPre: '/merchant.php/Config/pre',
  saveConfig: '/merchant.php/Config/update'
}

// 预加载
export function getPre (parameter) {
  return axios({
    url: api.configPre,
    method: 'get',
    params: parameter
  })
}
// 修改
export function saveConfig (data) {
  return axios({
    url: api.saveConfig,
    method: 'post',
    data: data
  })
}
